/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/assets/packs/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 2334);
/******/ })
/************************************************************************/
/******/ ({

/***/ 2334:
/***/ (function(module, exports, __webpack_require__) {

function importAll(r) {
  r.keys().forEach(r);
}

importAll(__webpack_require__(2335));

/***/ }),

/***/ 2335:
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./alert/alert.js": 2336,
	"./buy_component/buy.js": 2338,
	"./camp_reg_component/camp_reg.js": 2340,
	"./card_module/component.js": 2342,
	"./class_details/component.js": 2344,
	"./copy_text/component.js": 2346,
	"./dashboard/announcement_component/announcement_component.js": 2347,
	"./dashboard/photos_component/photos_component.js": 2348,
	"./dashboard/resource_card_component/resource_card_component.js": 2349,
	"./email_capture/email_capture.js": 2351,
	"./faq_accordion/component.js": 2353,
	"./faqs/component.js": 2355,
	"./forms/rich_text_area/rich_text_area.js": 2357,
	"./forms/tags_input/tags_input.js": 2359,
	"./global/banner_component.js": 2361,
	"./how_people_are_using_tg/component.js": 2362,
	"./image_accordion/component.js": 2364,
	"./image_overlayed_text/component.js": 2366,
	"./leader_info/card.js": 2368,
	"./leaders/evergreen_badge/evergreen_badge.js": 2370,
	"./modal/modal.js": 2372,
	"./my/dashboard_header_component/component.js": 2374,
	"./photo_slider/component.js": 2376,
	"./popover/component.js": 2378,
	"./promotional/banner.js": 2379,
	"./review/bar/bar.js": 2381,
	"./review/card/card.js": 2383,
	"./seasonal_learning_plan/component.js": 2385,
	"./share/social/social.js": 2387,
	"./swiper/component.js": 2388,
	"./teacher/ratings/ratings.js": 2390,
	"./user_menu/componenet.js": 2392,
	"./what_is_tinkergarten/component.js": 2394,
	"./what_we_are_learning_content/component.js": 2396,
	"./yellow_header_bar/component.js": 2398
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2335;

/***/ }),

/***/ 2336:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__notification_scss__ = __webpack_require__(2337);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__notification_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__notification_scss__);


/***/ }),

/***/ 2337:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 2338:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__buy_component_scss__ = __webpack_require__(2339);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__buy_component_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__buy_component_scss__);


/***/ }),

/***/ 2339:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 2340:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__camp_reg_component_scss__ = __webpack_require__(2341);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__camp_reg_component_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__camp_reg_component_scss__);


/***/ }),

/***/ 2341:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 2342:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__component_scss__ = __webpack_require__(2343);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__component_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__component_scss__);


/***/ }),

/***/ 2343:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 2344:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__component_css__ = __webpack_require__(2345);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__component_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__component_css__);

$(function () {
  return $('.toggle-details').on('click', function (e) {
    return $(e.currentTarget).toggleClass('show');
  });
});

/***/ }),

/***/ 2345:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 2346:
/***/ (function(module, exports) {

$(function () {
  $('.copy-text-component').on('click', function (e) {
    e.preventDefault();
    var btn = $(e.currentTarget);
    var text = btn.data('text-to-copy');
    var name = btn.data('copy-btn-name');
    var btnClass = btn.data('copy-btn-class');
    var $temp = $("<input>");
    $("body").append($temp);
    $temp.val(text).select();
    document.execCommand("copy");
    $temp.remove();
    btn.removeClass(btnClass).addClass('text-success font-bold').html('Copied!');
    setTimeout(function () {
      return btn.removeClass('text-success font-bold').addClass(btnClass).html(name);
    }, 2500);
  });
});

/***/ }),

/***/ 2347:
/***/ (function(module, exports) {

$(function () {
  $("#close-announcement-bar").click(function () {
    // Hide for 1 day
    var date = new Date();
    date.setDate(date.getDate() + 1);
    document.cookie = "hide_announcement_bar=true;expires=" + date.toUTCString() + ";path=/;";
    $(".announcement_component").addClass("hidden"); // Auto refresh page

    setTimeout(function () {
      window.location.reload();
    }, 1000);
  });
});

/***/ }),

/***/ 2348:
/***/ (function(module, exports) {

$(function () {
  // handle checkbox toggle
  $("#share-photos-toggle").on("change", function () {
    $(".checkbox-toggle").addClass('hidden');
    $("#share-preference-loader").removeClass('hidden');
    var errorMessage = "An unexpected error occurred!";
    $.ajax({
      type: 'PUT',
      url: "/accounts/update_share_photos_preference",
      data: {
        share_photos: this.checked
      },
      success: function success(data) {
        window.location.reload();
      },
      error: function error() {
        alert(errorMessage);
        window.location.reload();
      }
    });
  });
});

/***/ }),

/***/ 2349:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__resource_card_component_scss__ = __webpack_require__(2350);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__resource_card_component_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__resource_card_component_scss__);


/***/ }),

/***/ 2350:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 2351:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__region_scss__ = __webpack_require__(2352);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__region_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__region_scss__);


/***/ }),

/***/ 2352:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 2353:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__component_scss__ = __webpack_require__(2354);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__component_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__component_scss__);


(function () {
  document.addEventListener("DOMContentLoaded", function () {
    var headers = document.querySelectorAll(".faq_accordion__header");
    var carets = document.querySelectorAll(".faq_accordion__caret");
    headers.forEach(function (header) {
      header.addEventListener("click", function () {
        headers.forEach(function (h) {
          return h.classList.remove("open");
        });
        carets.forEach(function (h) {
          return h.classList.remove("rotate-180");
        });
        var currentContent = this.nextElementSibling;
        var isCurrent = currentContent.classList.contains("open");
        var caret = this.querySelector(".faq_accordion__caret");
        var openContent = document.querySelector(".faq_accordion__content.open");

        if (openContent) {
          openContent.classList.remove("open");
        }

        if (!isCurrent) {
          currentContent.classList.add("open");
          this.classList.toggle("open");
          caret.classList.toggle("rotate-180");
        }
      });
    });
  });
})();

/***/ }),

/***/ 2354:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 2355:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__component_css__ = __webpack_require__(2356);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__component_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__component_css__);

$(function () {
  $('.expandable-item').on('click', function (e) {
    var item = $(e.currentTarget);
    item.find('.expanding-body').toggleClass('hidden');
    item.find('.faq_caret').toggleClass('rotate-180');
  });
});

/***/ }),

/***/ 2356:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 2357:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__rich_text_area_scss__ = __webpack_require__(2358);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__rich_text_area_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__rich_text_area_scss__);
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}


addHeadingAttributes();
addForegroundColorAttributes();
addBackgroundColorAttributes();
Trix.config.attachments.preview.caption = {
  Name: false,
  Size: false
};
addEventListener("trix-initialize", function (event) {
  new RichText(event.target);
});
addEventListener("trix-action-invoke", function (event) {
  if (event.actionName === "x-horizontal-rule") insertHorizontalRule();

  function insertHorizontalRule() {
    event.target.editor.insertAttachment(buildHorizontalRule());
  }

  function buildHorizontalRule() {
    return new Trix.Attachment({
      content: "<hr>",
      contentType: "vnd.rubyonrails.horizontal-rule.html"
    });
  }
});
addEventListener("trix-attachment-add", function (event) {
  var attachableType = $(event.target).data('model-name');
  var attachableId = $(event.target).data('model-id');

  if (event.attachment.file && attachableType !== '' && attachableId !== '') {
    uploadFileAttachment(event.attachment, attachableType, attachableId);
  }
});

var RichText = /*#__PURE__*/function () {
  function RichText(element) {
    _classCallCheck(this, RichText);

    this.element = element;
    this.insertHeadingElements();
    this.insertDividerElements();
    this.insertColorElements();
  }

  _createClass(RichText, [{
    key: "insertHeadingElements",
    value: function insertHeadingElements() {
      this.removeOriginalHeadingButton();
      this.insertNewHeadingButton();
      this.insertHeadingDialog();
    }
  }, {
    key: "removeOriginalHeadingButton",
    value: function removeOriginalHeadingButton() {
      this.buttonGroupBlockTools.removeChild(this.originalHeadingButton);
    }
  }, {
    key: "insertNewHeadingButton",
    value: function insertNewHeadingButton() {
      this.buttonGroupBlockTools.insertAdjacentHTML("afterbegin", this.headingButtonTemplate);
    }
  }, {
    key: "insertHeadingDialog",
    value: function insertHeadingDialog() {
      this.dialogsElement.insertAdjacentHTML("beforeend", this.dialogHeadingTemplate);
    }
  }, {
    key: "insertDividerElements",
    value: function insertDividerElements() {
      this.quoteButton.insertAdjacentHTML("afterend", this.horizontalButtonTemplate);
    }
  }, {
    key: "insertColorElements",
    value: function insertColorElements() {
      this.insertColorButton();
      this.insertDialogColor();
    }
  }, {
    key: "insertColorButton",
    value: function insertColorButton() {
      this.buttonGroupTextTools.insertAdjacentHTML("beforeend", this.colorButtonTemplate);
    }
  }, {
    key: "insertDialogColor",
    value: function insertDialogColor() {
      this.dialogsElement.insertAdjacentHTML("beforeend", this.dialogColorTemplate);
    }
  }, {
    key: "buttonGroupBlockTools",
    get: function get() {
      return this.toolbarElement.querySelector("[data-trix-button-group=block-tools]");
    }
  }, {
    key: "buttonGroupTextTools",
    get: function get() {
      return this.toolbarElement.querySelector("[data-trix-button-group=text-tools]");
    }
  }, {
    key: "dialogsElement",
    get: function get() {
      return this.toolbarElement.querySelector("[data-trix-dialogs]");
    }
  }, {
    key: "originalHeadingButton",
    get: function get() {
      return this.toolbarElement.querySelector("[data-trix-attribute=heading1]");
    }
  }, {
    key: "quoteButton",
    get: function get() {
      return this.toolbarElement.querySelector("[data-trix-attribute=quote]");
    }
  }, {
    key: "toolbarElement",
    get: function get() {
      return this.element.toolbarElement;
    }
  }, {
    key: "horizontalButtonTemplate",
    get: function get() {
      return '<button type="button" class="trix-button trix-button--icon trix-button--icon-horizontal-rule" data-trix-action="x-horizontal-rule" tabindex="-1" title="Divider">Divider</button>';
    }
  }, {
    key: "headingButtonTemplate",
    get: function get() {
      return '<button type="button" class="trix-button trix-button--icon trix-button--icon-heading-1" data-trix-action="x-heading" title="Heading" tabindex="-1">Heading</button>';
    }
  }, {
    key: "colorButtonTemplate",
    get: function get() {
      return '<button type="button" class="trix-button trix-button--icon trix-button--icon-color" data-trix-action="x-color" title="Color" tabindex="-1">Color</button>';
    }
  }, {
    key: "dialogHeadingTemplate",
    get: function get() {
      return "\n      <div class=\"trix-dialog trix-dialog--heading\" data-trix-dialog=\"x-heading\" data-trix-dialog-attribute=\"x-heading\">\n        <div class=\"trix-dialog__link-fields\">\n          <input type=\"text\" name=\"x-heading\" class=\"trix-dialog-hidden__input\" data-trix-input>\n          <div class=\"trix-button-group\">\n            <button type=\"button\" class=\"trix-button trix-button--dialog\" data-trix-attribute=\"heading1\">H1</button>\n            <button type=\"button\" class=\"trix-button trix-button--dialog\" data-trix-attribute=\"heading2\">H2</button>\n            <button type=\"button\" class=\"trix-button trix-button--dialog\" data-trix-attribute=\"heading3\">H3</button>\n            <button type=\"button\" class=\"trix-button trix-button--dialog\" data-trix-attribute=\"heading4\">H4</button>\n            <button type=\"button\" class=\"trix-button trix-button--dialog\" data-trix-attribute=\"heading5\">H5</button>\n            <button type=\"button\" class=\"trix-button trix-button--dialog\" data-trix-attribute=\"heading6\">H6</button>\n          </div>\n        </div>\n      </div>\n    ";
    }
  }, {
    key: "dialogColorTemplate",
    get: function get() {
      return "\n      <div class=\"trix-dialog trix-dialog--color\" data-trix-dialog=\"x-color\" data-trix-dialog-attribute=\"x-color\">\n        <div class=\"trix-dialog__link-fields\">\n          <input type=\"text\" name=\"x-color\" class=\"trix-dialog-hidden__input\" data-trix-input>\n          <div class=\"trix-button-group\">\n            <button type=\"button\" class=\"trix-button trix-button--dialog\" data-trix-attribute=\"fgColor1\" data-trix-method=\"hideDialog\"></button>\n            <button type=\"button\" class=\"trix-button trix-button--dialog\" data-trix-attribute=\"fgColor2\" data-trix-method=\"hideDialog\"></button>\n            <button type=\"button\" class=\"trix-button trix-button--dialog\" data-trix-attribute=\"fgColor3\" data-trix-method=\"hideDialog\"></button>\n            <button type=\"button\" class=\"trix-button trix-button--dialog\" data-trix-attribute=\"fgColor4\" data-trix-method=\"hideDialog\"></button>\n            <button type=\"button\" class=\"trix-button trix-button--dialog\" data-trix-attribute=\"fgColor5\" data-trix-method=\"hideDialog\"></button>\n            <button type=\"button\" class=\"trix-button trix-button--dialog\" data-trix-attribute=\"fgColor6\" data-trix-method=\"hideDialog\"></button>\n            <button type=\"button\" class=\"trix-button trix-button--dialog\" data-trix-attribute=\"fgColor7\" data-trix-method=\"hideDialog\"></button>\n            <button type=\"button\" class=\"trix-button trix-button--dialog\" data-trix-attribute=\"fgColor8\" data-trix-method=\"hideDialog\"></button>\n            <button type=\"button\" class=\"trix-button trix-button--dialog\" data-trix-attribute=\"fgColor9\" data-trix-method=\"hideDialog\"></button>\n          </div>\n          <div class=\"trix-button-group\">\n            <button type=\"button\" class=\"trix-button trix-button--dialog\" data-trix-attribute=\"bgColor1\" data-trix-method=\"hideDialog\"></button>\n            <button type=\"button\" class=\"trix-button trix-button--dialog\" data-trix-attribute=\"bgColor2\" data-trix-method=\"hideDialog\"></button>\n            <button type=\"button\" class=\"trix-button trix-button--dialog\" data-trix-attribute=\"bgColor3\" data-trix-method=\"hideDialog\"></button>\n            <button type=\"button\" class=\"trix-button trix-button--dialog\" data-trix-attribute=\"bgColor4\" data-trix-method=\"hideDialog\"></button>\n            <button type=\"button\" class=\"trix-button trix-button--dialog\" data-trix-attribute=\"bgColor5\" data-trix-method=\"hideDialog\"></button>\n            <button type=\"button\" class=\"trix-button trix-button--dialog\" data-trix-attribute=\"bgColor6\" data-trix-method=\"hideDialog\"></button>\n            <button type=\"button\" class=\"trix-button trix-button--dialog\" data-trix-attribute=\"bgColor7\" data-trix-method=\"hideDialog\"></button>\n            <button type=\"button\" class=\"trix-button trix-button--dialog\" data-trix-attribute=\"bgColor8\" data-trix-method=\"hideDialog\"></button>\n            <button type=\"button\" class=\"trix-button trix-button--dialog\" data-trix-attribute=\"bgColor9\" data-trix-method=\"hideDialog\"></button>\n          </div>\n        </div>\n      </div>\n    ";
    }
  }]);

  return RichText;
}();

function addHeadingAttributes() {
  Array.from(["h1", "h2", "h3", "h4", "h5", "h6"]).forEach(function (tagName, i) {
    Trix.config.blockAttributes["heading".concat(i + 1)] = {
      tagName: tagName,
      terminal: true,
      breakOnReturn: true,
      group: false
    };
  });
}

function addForegroundColorAttributes() {
  Array.from(["rgb(136, 118, 38)", "rgb(185, 94, 6)", "rgb(207, 0, 0)", "rgb(216, 28, 170)", "rgb(144, 19, 254)", "rgb(5, 98, 185)", "rgb(17, 138, 15)", "rgb(148, 82, 22)", "rgb(102, 102, 102)"]).forEach(function (color, i) {
    Trix.config.textAttributes["fgColor".concat(i + 1)] = {
      style: {
        color: color
      },
      inheritable: true,
      parser: function parser(e) {
        return e.style.color == color;
      }
    };
  });
}

function addBackgroundColorAttributes() {
  Array.from(["rgb(250, 247, 133)", "rgb(255, 240, 219)", "rgb(255, 229, 229)", "rgb(255, 228, 247)", "rgb(242, 237, 255)", "rgb(225, 239, 252)", "rgb(228, 248, 226)", "rgb(238, 226, 215)", "rgb(242, 242, 242)"]).forEach(function (color, i) {
    Trix.config.textAttributes["bgColor".concat(i + 1)] = {
      style: {
        backgroundColor: color
      },
      inheritable: true,
      parser: function parser(e) {
        return e.style.backgroundColor == color;
      }
    };
  });
}

function uploadFileAttachment(attachment, attachableType, attachableId) {
  uploadFile(attachment.file, attachableType, attachableId, setProgress, setAttributes);

  function setProgress(progress) {
    attachment.setUploadProgress(progress);
  }

  function setAttributes(attributes) {
    attachment.setAttributes(attributes);
  }
}

function uploadFile(file, attachableType, attachableId, progressCallback, successCallback) {
  var HOST = "/admin/attachments";
  var csrfToken = document.querySelectorAll('meta[name=csrf-token]')[0].getAttribute("content");
  var formData = createFormData(file, attachableType, attachableId);
  var xhr = new XMLHttpRequest();
  xhr.open("POST", HOST, true);
  xhr.setRequestHeader('X-CSRF-Token', csrfToken);
  xhr.upload.addEventListener("progress", function (event) {
    var progress = event.loaded / event.total * 100;
    progressCallback(progress);
  });
  xhr.addEventListener("load", function (event) {
    var data = JSON.parse(xhr.responseText);

    if (xhr.status === 201) {
      var attributes = {
        url: data.fileUrl,
        href: data.fileUrl + "?content-disposition=attachment"
      };
      successCallback(attributes);
    }
  });
  xhr.send(formData);
}

function createFormData(file, attachableType, attachableId) {
  var data = new FormData();
  data.append("Content-Type", file.type);
  data.append("file", file);
  data.append("attachable_type", attachableType);
  data.append("attachable_id", attachableId);
  return data;
}

/***/ }),

/***/ 2358:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 2359:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__tags_input_scss__ = __webpack_require__(2360);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__tags_input_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__tags_input_scss__);


/***/ }),

/***/ 2360:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 2361:
/***/ (function(module, exports) {

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

$().ready(function () {
  var bannerElement = document.getElementById("global-banner");

  if (bannerElement) {
    globalComponentRendered(bannerElement);
    bannerElement.onclick = globalComponentClicked;
  }
});

function globalComponentRendered(bannerElement) {
  if (window.analytics) {
    window.analytics.track("Banner Displayed", analyticsData());
  }
}

function globalComponentClicked() {
  if (window.analytics) {
    window.analytics.track("Banner Clicked", analyticsData());
  }
}

function analyticsData() {
  var bannerData = $('#global-banner').data('analytics');
  var tgaPageData = new TgAnalytics().pageData;
  return _objectSpread(_objectSpread({}, bannerData), tgaPageData);
}

/***/ }),

/***/ 2362:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__component_scss__ = __webpack_require__(2363);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__component_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__component_scss__);


/***/ }),

/***/ 2363:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 2364:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__component_scss__ = __webpack_require__(2365);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__component_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__component_scss__);


(function () {
  document.addEventListener("DOMContentLoaded", function () {
    var headers = document.querySelectorAll(".accordion__header");
    headers.forEach(function (header) {
      header.addEventListener("click", function () {
        headers.forEach(function (h) {
          return h.classList.remove("open");
        });
        var currentContent = this.nextElementSibling;
        var isCurrent = currentContent.classList.contains("open");
        var openContent = document.querySelector(".accordion__content.open");

        if (openContent) {
          openContent.classList.remove("open");
        }

        if (!isCurrent) {
          currentContent.classList.add("open");
          this.classList.toggle("open");
        }
      });
    });
  });
})();

/***/ }),

/***/ 2365:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 2366:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__component_scss__ = __webpack_require__(2367);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__component_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__component_scss__);


/***/ }),

/***/ 2367:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 2368:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__card_scss__ = __webpack_require__(2369);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__card_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__card_scss__);


/***/ }),

/***/ 2369:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 2370:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__evergreen_badge_scss__ = __webpack_require__(2371);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__evergreen_badge_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__evergreen_badge_scss__);

$(function () {
  var evergreenLogo = $('#evergreenLogo');
  var evergreenTooltip = $('.evergreen-tooltip');
  evergreenLogo.on("mouseenter", function () {
    return evergreenTooltip.removeClass('hidden');
  });
  evergreenLogo.on("mouseout", function () {
    return evergreenTooltip.addClass('hidden');
  });
  evergreenLogo.on("tap", function () {
    return evergreenTooltip.toggleClass('hidden');
  });
});

/***/ }),

/***/ 2371:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 2372:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__component_scss__ = __webpack_require__(2373);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__component_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__component_scss__);


/***/ }),

/***/ 2373:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 2374:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__dashboard_header_component_scss__ = __webpack_require__(2375);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__dashboard_header_component_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__dashboard_header_component_scss__);


/***/ }),

/***/ 2375:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 2376:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__component_scss__ = __webpack_require__(2377);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__component_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__component_scss__);


/***/ }),

/***/ 2377:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 2378:
/***/ (function(module, exports) {

$(function () {
  var trigger = $('.popover-component');
  var popover = $('.popover');
  trigger.on('click', function () {
    return popover.toggleClass('hidden');
  });
  trigger.on('mouseover', function () {
    return popover.toggleClass('hidden');
  });
});

/***/ }),

/***/ 2379:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__banner_scss__ = __webpack_require__(2380);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__banner_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__banner_scss__);

$(function () {
  $(".promo_banner_close_button").on("click", function () {
    return $(".promo-banner-component").addClass('hidden invisible');
  });
});

/***/ }),

/***/ 2380:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 2381:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__bar_scss__ = __webpack_require__(2382);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__bar_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__bar_scss__);


/***/ }),

/***/ 2382:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 2383:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__card_scss__ = __webpack_require__(2384);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__card_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__card_scss__);


/***/ }),

/***/ 2384:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 2385:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__component_scss__ = __webpack_require__(2386);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__component_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__component_scss__);


/***/ }),

/***/ 2386:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 2387:
/***/ (function(module, exports) {

$(document).ready(function () {
  // handle share facebook / twitter
  $('.share-popup').on('click', function (e) {
    var link = $(e.currentTarget); // pop-up window size

    var config = {
      width: 626,
      height: 300
    }; // popup position

    var px = Math.floor(((screen.availWidth || 1024) - config.width) / 2),
        py = Math.floor(((screen.availHeight || 700) - config.height) / 2); // open popup

    var popup = window.open(link.data('url'), "social", "width=" + config.width + ",height=" + config.height + ",left=" + px + ",top=" + py + ",location=0,menubar=0,toolbar=0,status=0,scrollbars=1,resizable=1");

    if (popup) {
      popup.focus();
      if (e.preventDefault) e.preventDefault();
      e.returnValue = false;
    }
  });
});

/***/ }),

/***/ 2388:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__component_scss__ = __webpack_require__(2389);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__component_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__component_scss__);


/***/ }),

/***/ 2389:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 2390:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ratings_scss__ = __webpack_require__(2391);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ratings_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__ratings_scss__);


/***/ }),

/***/ 2391:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 2392:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__component_scss__ = __webpack_require__(2393);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__component_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__component_scss__);


/***/ }),

/***/ 2393:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 2394:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__component_scss__ = __webpack_require__(2395);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__component_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__component_scss__);


/***/ }),

/***/ 2395:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 2396:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__component_scss__ = __webpack_require__(2397);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__component_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__component_scss__);


/***/ }),

/***/ 2397:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 2398:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__component_scss__ = __webpack_require__(2399);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__component_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__component_scss__);


/***/ }),

/***/ 2399:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })

/******/ });


// WEBPACK FOOTER //
// components-d0130c97c48a3e47b46f.js